export const checkIsDefaultSelectName = (name: string) =>
  name.includes('Select_')
